const _ = require("lodash");
const PT = require("prop-types");
const React = require("react");
const createReactClass = require("create-react-class");
const withVaultUpdate = require("../hoc/withVaultUpdate");
const withVaultDispatch = require("../hoc/withVaultDispatch");
const AT = require("../vault/ActionTypes");
const {
	atCurrBlock,
	atCurrLabBlock,
	atCurrResult,
	atDemo,
	atPage,
	atTempUser,
	atTheaterSetByPage,
} = require("../vault/StateCursors");
const OpsChapterPath = require("../vault/OpsChapterPath");
const OpsUser = require("../vault/OpsUser");
const OpsPage = require("../vault/OpsPage");
const URLMake = require("../../../shared/URLMake");
const DemoBar = require("./DemoBar");
const LevelProgressBar = require("./LevelProgressBar");
const IconButton = require("./IconButton");
const {Icon} = require("./Icon");
const HelpModal = require("./TutorialModal");
const SettingsModal = require("./SettingsModal");
const LeaderboardsModal = require("./LeaderboardsModal");
const GradeModal = require("./GradeModal");
const TopBarUser = require("./TopBarUser");
const ArrowIcon = require("./ArrowIcon");
const MessageModal = require("./MessageModal");
const Modal = require("./Modal");
const Avatar = require("./Avatar");
const dbDemoData = require("../../../shared/data/dbDemoData.json");
const {LeaderboardsLocked} = require("../util/components/LeaderboardsLocked");
const Sounds = require("../util/Sounds");
const AssetsUtil = require("../util/AssetsUtil");
const {shouldRenderLeftSideNavBar} = require("../util/NavigationUtil");
const {PortalDestination} = require("./PortalDestination");
const {Portal} = require("./Portal");
const {PORTAL_CONTAINERS} = require("../../../shared/PortalConstants");
const PageShared = require("../../../shared/PageShared");
const NavButton = require("./NavButton").default;
const {ICON_MAP} = require("../util/NavIcons");
const {shouldSimplifyNavigation} = require("../util/NavigationUtil");

const styles = require("./styles/TopBar.css");

const getPropsFromVault = (props, vaultState) => {
	const page = atPage(vaultState).get();
	const user = vaultState.page.demo ? atTempUser(vaultState).get() : props.user;

	return {
		avatarChapterURL: OpsChapterPath.getChapterURLForAvatar(vaultState),
		page,
		block: atCurrBlock(vaultState).get(),
		labBlock: atCurrLabBlock(vaultState).get(),
		theaterSet: atTheaterSetByPage(vaultState, page).get(),
		user,
		demoTutorialShown: atDemo(vaultState).getIn("showing"),
		result: atCurrResult(vaultState).get(),
	};
};

// Helper to apply higher-order components.
const augment = function(Component) {
	Component = withVaultDispatch(Component);
	Component = withVaultUpdate(Component, getPropsFromVault);
	return Component;
};

module.exports = augment(
	createReactClass({
		displayName: "TrainerTopBar",

		propTypes: {
			user: PT.object.isRequired,
			isProblemPage: PT.bool,
			barEl: PT.element, // Defaults to LevelProgressBar
			isExpandable: PT.bool,
			demo: PT.bool,
			forLab: PT.bool, // whether it's for lab lobby or type pages
			labType: PT.number, // the lab type; type === 0 for lobby
			showOldProgressWithLeftNav: PT.bool,

			// Injected by HOCs
			avatarChapterURL: PT.string,
			dispatch: PT.func.isRequired,
			demoTutorialShown: PT.string,
			page: PT.object.isRequired,
			block: PT.object,
			labBlock: PT.object,
			theaterSet: PT.object,
			result: PT.object,
		},

		// Used by vault update HOC
		vaultEvents: {
			toggleTopBar: function(isOpen) {
				this.setState({isTopBarOpen: isOpen});
			},
			reportBug: function() {
				// Close help modal if reporting bug
				this.setState({isHelpModalOpen: false});
			},
			unlockedSpace: function(space) {
				// Space will tell us which modal we need to show
				this.setState({
					activeTooltipInfo: {
						iconName: space === "theater" ? "projector" : "book",
						type: "unlock",
						extra: space,
					},
				});
			},
			topBarNotification: function(type) {
				// Don't show this notifiction if student just starting BA
				if (this.state.isHelpModalOpen) return;
				this.setState({
					activeTooltipInfo: {
						iconName: "help",
						type,
					},
				});
			},
		},

		getInitialState: function() {
			const {isExpandable} = this.props;
			return {
				isHelpModalOpen: false,
				isSettingsModalOpen: false,
				isLeaderboardsModalOpen: false,
				isGradeModalOpen: false,
				isTopBarOpen: !isExpandable,
				activeTooltipInfo: null,
				isMoreDropdownOpen: false,
			};
		},

		componentDidMount: function() {
			const {user, page} = this.props;
			if (
				_.get(page, "shouldOpenLeaderboards") &&
				OpsUser.canViewLeaderboards(user)
			) {
				this.openLeaderboardsModal();
			}
			if (this.state.activeTooltipInfo) {
				this._addTooltipOutsideClickListener();
			}
		},

		componentDidUpdate: function(prevProps, prevState) {
			const hadTooltip = !!prevState.activeTooltipInfo;
			const hasTooltip = !!this.state.activeTooltipInfo;
			if (!hadTooltip && hasTooltip) {
				this._addTooltipOutsideClickListener();
			} else if (hadTooltip && !hasTooltip) {
				this._removeTooltipOutsideClickListener();
			}
		},

		_addTooltipOutsideClickListener: function() {
			if (this._tooltipOutsideClickBound) return;
			this._tooltipOutsideClickBound = function(event) {
				if (this._topBarEl && !this._topBarEl.contains(event.target)) {
					this.closeSpaceModal();
				}
			}.bind(this);
			document.addEventListener("mousedown", this._tooltipOutsideClickBound);
		},

		_removeTooltipOutsideClickListener: function() {
			if (!this._tooltipOutsideClickBound) return;
			document.removeEventListener("mousedown", this._tooltipOutsideClickBound);
			this._tooltipOutsideClickBound = null;
		},

		componentWillUnmount: function() {
			this._removeTooltipOutsideClickListener();
			// This records the leaderboards modal as being closed
			// in vault state, which is important for time tracking.
			// Needed on unmount so that time tracking doesn't continue for
			// leaderboards if someone closes the modal via navigating to a
			// different page.
			this.closeLeaderboardsModal();
		},

		toggleTopBar: function() {
			const clickSound = this.state.isTopBarOpen ? "arrow-left" : "arrow-right";
			Sounds.playSound(clickSound);
			const willBeOpen = !this.state.isTopBarOpen;
			this.setState({
				isTopBarOpen: willBeOpen,
				isUnlockedLibraryModalOpen: false,
				isUnlockedTheaterModalOpen: false,
			});
		},

		openHelpModal: function() {
			const newState = {isHelpModalOpen: true};
			if (_.get(this.state, "activeTooltipInfo.iconName") === "help") {
				// Clear any blurbs under help
				newState.activeTooltipInfo = null;
			}
			this.setState(newState);
		},

		closeHelpModal: function() {
			this.setState({isHelpModalOpen: false});
			this.props.dispatch({
				type: AT.CLOSE_MODAL_IN_THEATER,
			});
		},

		openSettingsModal: function() {
			this.setState({isSettingsModalOpen: true});
			this.props.dispatch({
				type: AT.OPEN_SETTINGS_MODAL,
			});
		},

		closeSettingsModal: function() {
			this.setState({isSettingsModalOpen: false});
			this.props.dispatch({
				type: AT.CLOSE_MODAL_IN_THEATER,
			});
		},

		openLeaderboardsModal: function() {
			const {user, page, result} = this.props;
			if (
				OpsPage.isCurrentlyTakingTest(user, page) &&
				!OpsUser.hasKey(user, "trainer allow unfinished test")
			) {
				const messageType =
					result && result.resultType === "bookTest"
						? "finishBookTest"
						: "finishTestOrQuit";
				this.props.dispatch({
					type: AT.SHOW_CONFIRM,
					messageType,
					data: {
						onConfirmDispatch: {
							type: AT.SET_PAGE,
							pageState: URLMake.state.forOverview(result),
						},
						styleType: "grade" + page.gradeNumber,
					},
				});
				return;
			}

			this.setState({isLeaderboardsModalOpen: true});
			this.props.dispatch({
				type: AT.OPEN_LEADERBOARDS_MODAL,
			});
		},

		closeLeaderboardsModal: function() {
			this.setState({isLeaderboardsModalOpen: false});
			this.props.dispatch({
				type: AT.CLOSE_LEADERBOARDS_MODAL,
			});
		},

		toggleMoreDropdown: function() {
			if (!shouldSimplifyNavigation(this.props.page)) return;
			this.setState(prev => ({isMoreDropdownOpen: !prev.isMoreDropdownOpen}));
		},

		closeSpaceModal: function() {
			this.setState({activeTooltipInfo: null});
			this.props.dispatch({
				type: AT.UPDATE_SHOW_NOTIFICATION,
				isShowingNotification: false,
			});
		},

		generateClassURL: function() {
			const {avatarChapterURL, user} = this.props;
			return avatarChapterURL ?? URLMake.forDefaultTrainerPage(user);
		},

		render: function() {
			const {
				page,
				user,
				block,
				labBlock,
				theaterSet,
				demoTutorialShown,
				demo,
				forLab,
				labType,
			} = this.props;

			const shouldSimplifyTopNav = shouldSimplifyNavigation(this.props.page);

			const {activeTooltipInfo} = this.state;

			const pageName = page.name;

			const urlTable = {
				["ribbon"]: URLMake.forProfileDefault(),
				[ICON_MAP.BELL]: this.generateClassURL(),
				[ICON_MAP.PROJECTOR]: URLMake.forDefaultTheaterGrade(user),
				[ICON_MAP.BOOK]: URLMake.forDefaultLibraryGrade(user),
				["baHome"]: URLMake.forHome(),
				[ICON_MAP.HOMEWORK]: URLMake.forHomework(),
				[ICON_MAP.BEAM]: _.get(user, "model.classURL"),
				[ICON_MAP.PUZZLE_LAB]: URLMake.forLabLobby(),
			};
			if (demo) {
				urlTable.bell = URLMake.forDemoChapter();
				urlTable.book = URLMake.forDemoLibraryGrade();
				urlTable.projector = URLMake.forDemoTheaterChapter();
			}
			const soundTable = {
				baHome: "top-bar-icon-3",
				[ICON_MAP.BELL]: "top-bar-icon-1",
				[ICON_MAP.BOOK]: "top-bar-icon-2",
				[ICON_MAP.PROJECTOR]: "top-bar-icon-3",
				[ICON_MAP.SETTINGS]: "top-bar-icon-1",
				[ICON_MAP.HOMEWORK]: "top-bar-icon-2",
				[ICON_MAP.HELP]: ["top-bar-icon-3", "whoosh"],
				[ICON_MAP.LEADERBOARDS]: ["top-bar-icon-1"],
				[ICON_MAP.BEAM]: "top-bar-icon-3",
				[ICON_MAP.PUZZLE_LAB]: "top-bar-icon-2",
				[ICON_MAP.MORE]: "top-bar-icon-1",
			};
			const iconPageNameMap = {
				[ICON_MAP.BELL]: "trainer.chapter",
				[ICON_MAP.PROJECTOR]: "theater.chapter",
				[ICON_MAP.BOOK]: "library.grade",
				[ICON_MAP.PUZZLE_LAB]: "lab.lobby",
			};

			let settingsModal = null;
			if (this.state.isSettingsModalOpen) {
				settingsModal = (
					<SettingsModal
						onClose={this.closeSettingsModal}
						user={user}
						demo={this.props.demo}
					/>
				);
			}

			let helpModal = null;
			if (this.state.isHelpModalOpen) {
				helpModal = (
					<HelpModal
						className={styles.helpModal}
						onClose={this.closeHelpModal}
						page={page}
						block={block}
						labBlock={labBlock}
						theaterSet={theaterSet}
						user={user}
						demo={demo}
						forLab={forLab}
						labType={labType}
						closeOnEsc
					/>
				);
			}

			let leaderboardsModal = null;
			if (this.state.isLeaderboardsModalOpen) {
				const hasLeaderboardsAccess = OpsUser.canAccessLeaderboards(user);
				if (hasLeaderboardsAccess) {
					const isAcademy =
						OpsUser.isAcademyUser(user) ||
						OpsUser.isAcademyStaff(user) ||
						OpsUser.hasOpsAcademyRole(user);
					leaderboardsModal = (
						<LeaderboardsModal
							onClose={this.closeLeaderboardsModal}
							user={user}
							demo={this.props.demo}
							isAcademyUser={isAcademy}
						/>
					);
				} else {
					leaderboardsModal = (
						<MessageModal
							styleType="default"
							levelType="aboveAll"
							size={"extra-extra-large"}
							onClose={this.closeLeaderboardsModal}
						>
							<LeaderboardsLocked />
						</MessageModal>
					);
				}
			}

			let gradeModal = null;
			if (this.state && this.state.isGradeModalOpen && shouldSimplifyTopNav) {
				gradeModal = (
					<GradeModal
						onClose={() => this.setState({isGradeModalOpen: false})}
						user={this.props.user}
						forChapter={
							!OpsPage.isInLibrary(page) && !OpsPage.isInLibrary(page)
						}
						forLibrary={OpsPage.isInLibrary(page)}
						forTheater={OpsPage.isInTheater(page)}
					/>
				);
			}

			let barEl = this.props.barEl;
			const isOpen = this.state.isTopBarOpen;

			if (this.props.demo)
				barEl = <DemoBar isExpandable={this.props.isExpandable} />;

			if (!barEl) {
				barEl = (
					<LevelProgressBar
						className={this.props.isExpandable ? styles.levelBar : ""}
						xp={this.props.user.model.xp}
						isExpandable={this.props.isExpandable}
						isOpen={isOpen}
					/>
				);
			}

			let mainClass = isOpen ? styles.open : styles.closed;
			if (demoTutorialShown === "home2ndVisit")
				mainClass += " " + styles.demoHighlight;
			if (shouldRenderLeftSideNavBar(page)) {
				if (this.props.showOldProgressWithLeftNav) {
					return (
						<div
							className={mainClass}
							ref={el => {
								this._topBarEl = el;
							}}
						>
							<div className={styles.minimalStatic}>{barEl}</div>
						</div>
					);
				} else {
					return null;
				}
			}

			const tab = this.props.isExpandable ? (
				<div className={styles.tab} onClick={this.toggleTopBar}>
					<ArrowIcon
						direction={isOpen ? "up" : "down"}
						type={"tail-wonky"}
						colorName={"blue"}
						preventScaleHover={true}
						size={1.5}
						useWonkyCursor={true}
					/>
				</div>
			) : null;

			let hwButton;

			const showHomework = _.get(user, "model.showHomework");
			const showBEAM = _.get(user, "model.classURL");

			const navButtonClasses = {
				root: styles.navButtonRoot,
				icon: styles.navButtonIcon,
				label: styles.navButtonLabel,
			};

			if (showHomework) {
				hwButton = (
					<NavButton
						classes={{
							...navButtonClasses,
							root: styles.homework,
						}}
						iconName={"homework"}
						isSelected={OpsPage.isOnHomeworkTab(page)}
						clickSound={soundTable.homework}
						linkTo={urlTable["homework"]}
						label="HW"
					/>
				);
			}
			const canViewLeaderboards = OpsUser.canViewLeaderboards(user);

			let imgClass = styles.image;
			if (process.env.NODE_ENV !== "production" && !shouldSimplifyTopNav) {
				imgClass += " " + styles.debug;
			}

			const userRecentPageData = PageShared.getMostRecentPageDataForUser(user);
			// Several fallbacks here. First try for page.gradeNumber. This is so that if the user is navigating between
			// chapters, the topbar should reflect the current page. If the page.gradeNumber doesn't exist (e.g. when in
			// puzzle lab, or campus view), default to the user's most recent page data. If that doesn't exist default to
			// user.gradeNumber, and if all else fails, just default to "3".
			const gradeNumber =
				page.gradeNumber ??
				userRecentPageData.gradeNumber ??
				user.model?.gradeNumber ??
				"3";

			const baHomeLink = (
				<div className={styles.homeContainer}>
					<div className={styles.iconOuter}>
						{shouldSimplifyTopNav ? (
							<IconButton
								iconName={"baHome"}
								iconEl={
									<Icon
										gradeNumber={gradeNumber}
										color={"white"}
										className={styles.iconSimplified}
									/>
								}
								clickSound={soundTable.baHome}
								linkTo={urlTable["baHome"]}
							/>
						) : (
							<IconButton
								iconName={"baHome"}
								clickSound={soundTable.baHome}
								linkTo={urlTable["baHome"]}
							/>
						)}
					</div>
				</div>
			);

			let topBarType;
			if (shouldSimplifyTopNav) {
				topBarType = `simplified-level-${gradeNumber}`;
			}
			const topBarAsset = AssetsUtil.getTopBar(topBarType);
			const isTheaterUnlocked =
				shouldSimplifyTopNav ||
				_.get(user, ["model", "activity", "hasSeenTheater"], false) ||
				demo;
			const isLibraryUnlocked =
				shouldSimplifyTopNav ||
				_.get(user, ["model", "activity", "hasSeenLibrary"], false) ||
				demo ||
				OpsUser.isSchoolStudent(user);

			const isIconSelected = iconName => {
				// Collapsed Library+Theater: Videos tab keeps page name
				// library.grade but should highlight the projector; Guide Books
				// highlights the book.
				if (iconName === ICON_MAP.PROJECTOR) {
					return (
						page.tab === "videos" ||
						_.includes(pageName, iconPageNameMap[iconName])
					);
				}
				if (iconName === ICON_MAP.BOOK) {
					return (
						page.tab !== "videos" &&
						_.includes(pageName, iconPageNameMap[iconName])
					);
				}
				return _.includes(pageName, iconPageNameMap[iconName]);
			};

			const horizontalNavButtonClasses = shouldSimplifyTopNav
				? {
						outer: styles.horizontalNavButtonOuter,
						root: styles.horizontalNavButton,
						icon: styles.horizontalNavButtonIcon,
						label: styles.horizontalNavButtonLabel,
						underline: styles.horizontalNavButtonUnderline,
				  }
				: navButtonClasses;
			const beamButton = showBEAM ? (
				<NavButton
					iconName={"beam"}
					label="BEAM"
					isExternal={true}
					clickSound={soundTable.beam}
					linkTo={urlTable["beam"]}
					classes={horizontalNavButtonClasses}
				/>
			) : null;
			const rankingButton =
				canViewLeaderboards && !this.props.demo ? (
					<NavButton
						iconName={ICON_MAP.LEADERBOARDS}
						label="Ranking"
						clickSound={soundTable.leaderboards}
						handleClick={() => {
							this.openLeaderboardsModal();
							this.toggleMoreDropdown();
						}}
						tooltipInfo={activeTooltipInfo}
						onTooltipClick={this.closeSpaceModal}
						classes={horizontalNavButtonClasses}
					/>
				) : null;
			const settingsButton = (
				<NavButton
					iconName={ICON_MAP.SETTINGS}
					label="Settings"
					clickSound={soundTable[ICON_MAP.SETTINGS]}
					handleClick={() => {
						this.openSettingsModal();
						this.toggleMoreDropdown();
					}}
					tooltipInfo={activeTooltipInfo}
					onTooltipClick={this.closeSpaceModal}
					classes={horizontalNavButtonClasses}
				/>
			);
			const allChaptersButton = (
				<NavButton
					iconName={ICON_MAP.INDEX}
					label="All Chapters"
					clickSound={soundTable[ICON_MAP.SETTINGS]}
					handleClick={() => {
						this.setState({isGradeModalOpen: true});
						this.toggleMoreDropdown();
					}}
					tooltipInfo={activeTooltipInfo}
					onTooltipClick={this.closeSpaceModal}
					classes={horizontalNavButtonClasses}
				/>
			);
			const bugReportButton = OpsUser.canReportBugs(user) ? (
				<NavButton
					iconName={ICON_MAP.BUG}
					label="Report a Bug"
					clickSound={soundTable[ICON_MAP.SETTINGS]}
					handleClick={() => {
						this.props.dispatch({
							type: AT.REPORT_BUG,
						});
						this.toggleMoreDropdown();
					}}
					tooltipInfo={activeTooltipInfo}
					onTooltipClick={this.closeSpaceModal}
					classes={horizontalNavButtonClasses}
				/>
			) : null;
			const logoutButton = (
				<NavButton
					iconName={ICON_MAP.LOGOUT}
					label="Sign Out"
					clickSound={"logout"}
					handleClick={() => {
						this.props.dispatch({
							type: AT.LOGOUT_USER_REQUEST,
						});
						this.toggleMoreDropdown();
					}}
					tooltipInfo={activeTooltipInfo}
					onTooltipClick={this.closeSpaceModal}
					classes={horizontalNavButtonClasses}
				/>
			);
			const moreDropdownModal =
				this.state.isMoreDropdownOpen && shouldSimplifyTopNav ? (
					<Modal
						backdropClass={styles.moreDropdownContainerBackdrop}
						modalClass={styles.moreDropdownContainer}
						hasCloseButton={false}
						closeOnBackdropClick
						closeOnEsc
						onClose={() => this.setState({isMoreDropdownOpen: false})}
					>
						{allChaptersButton}
						{rankingButton}
						{settingsButton}
						{beamButton}
						{bugReportButton}
						{logoutButton}
					</Modal>
				) : null;

			return (
				<div
					className={mainClass}
					style={shouldSimplifyTopNav ? {left: "7%"} : {}}
					ref={el => {
						this._topBarEl = el;
					}}
				>
					<div
						className={
							shouldSimplifyTopNav ? styles.simplifiedStatic : styles.static
						}
					>
						<img
							className={imgClass}
							src={shouldSimplifyTopNav ? topBarAsset : topBarAsset}
						/>
						{tab}
						{baHomeLink}
						<div className={styles.leftIcons}>
							{hwButton}
							{shouldSimplifyTopNav ? null : beamButton}
							<NavButton
								iconName={ICON_MAP.BELL}
								label="Class"
								linkTo={urlTable[ICON_MAP.BELL]}
								clickSound={soundTable[ICON_MAP.BELL]}
								isSelected={isIconSelected(ICON_MAP.BELL)}
								tooltipInfo={activeTooltipInfo}
								onTooltipClick={this.closeSpaceModal}
								classes={navButtonClasses}
							/>
							<NavButton
								iconName={ICON_MAP.BOOK}
								label="Library"
								isDisabled={!isLibraryUnlocked}
								linkTo={urlTable[ICON_MAP.BOOK]}
								clickSound={soundTable[ICON_MAP.BOOK]}
								isSelected={isIconSelected(ICON_MAP.BOOK)}
								tooltipInfo={activeTooltipInfo}
								onTooltipClick={this.closeSpaceModal}
								classes={navButtonClasses}
							/>
							<NavButton
								iconName={ICON_MAP.PROJECTOR}
								label="Theater"
								isDisabled={!isTheaterUnlocked}
								linkTo={urlTable[ICON_MAP.PROJECTOR]}
								clickSound={soundTable[ICON_MAP.PROJECTOR]}
								isSelected={isIconSelected(ICON_MAP.PROJECTOR)}
								tooltipInfo={activeTooltipInfo}
								onTooltipClick={this.closeSpaceModal}
								classes={navButtonClasses}
							/>
						</div>
						<div
							className={
								shouldSimplifyTopNav
									? styles.rightIconsSimplified
									: styles.rightIcons
							}
						>
							{shouldSimplifyTopNav ? (
								<>
									{!demo && (
										<NavButton
											iconName={ICON_MAP.PUZZLE_LAB}
											label="Puzzle Lab"
											linkTo={urlTable[ICON_MAP.PUZZLE_LAB]}
											clickSound={soundTable[ICON_MAP.PUZZLE_LAB]}
											isSelected={isIconSelected(ICON_MAP.PUZZLE_LAB)}
											tooltipInfo={activeTooltipInfo}
											onTooltipClick={this.closeSpaceModal}
											classes={navButtonClasses}
										/>
									)}
									<NavButton
										icon={
											<Avatar
												hasSurround={true}
												className={styles.avatar}
												avatar={
													demo ? dbDemoData.avatarModel : user.model?.avatar
												}
											/>
										}
										iconName={"avatar"}
										label="Profile"
										linkTo={URLMake.forProfileDefault()}
										isSelected={pageName === "profile.main"}
										clickSound={soundTable[ICON_MAP.PUZZLE_LAB]}
										tooltipInfo={activeTooltipInfo}
										onTooltipClick={this.closeSpaceModal}
										classes={navButtonClasses}
									/>
									<NavButton
										iconName={ICON_MAP.MORE}
										label="More"
										clickSound={soundTable[ICON_MAP.MORE]}
										handleClick={() => this.toggleMoreDropdown()}
										tooltipInfo={activeTooltipInfo}
										onTooltipClick={this.closeSpaceModal}
										classes={navButtonClasses}
									/>
								</>
							) : (
								<>
									{rankingButton}
									<NavButton
										iconName={ICON_MAP.HELP}
										label="Help"
										clickSound={soundTable[ICON_MAP.HELP]}
										handleClick={() => this.openHelpModal()}
										tooltipInfo={activeTooltipInfo}
										onTooltipClick={this.closeSpaceModal}
										classes={navButtonClasses}
									/>
									{settingsButton}
								</>
							)}
						</div>
						{shouldSimplifyTopNav ? null : (
							<TopBarUser
								user={this.props.user}
								page={this.props.page}
								demo={this.props.demo}
							/>
						)}
						{barEl}
						<Portal container={PORTAL_CONTAINERS.HELP_MODAL}>
							{helpModal}
							{moreDropdownModal}
						</Portal>
						{settingsModal}
						{leaderboardsModal}
						{gradeModal}
					</div>
					<PortalDestination name={PORTAL_CONTAINERS.USER_PULLOUT_MENU} />
				</div>
			);
		},
	})
);
